import React, { Component } from 'react';

import ENV from '../../run-config';

export default class Footer extends Component{

  renderImpressLink(){
    if(ENV.impressUrl){
      return (
        <a href={ENV.impressUrl}>Impressum & Nutzungsbedingungen</a>
      )
    }


    return (
      <a onClick={() => this.props.onNavigate("/impressum")}>Impressum & Nutzungsbedingungen</a>
    )
  }

  renderFooterRLB(){
    return  (
      <footer style={{backgroundColor: '#666666', height: 60, position: 'relative', paddingTop: 13}}>
        <div className="col-md-12 col-lg-10 col-lg-offset-1">
          <p style={{color: 'darkgrey', fontSize: 14}}>
            <a style={{color: 'darkgrey'}} target="_blank" href={this.props.config.impressUrl || ENV.impressUrl}>Impressum & Nutzungsbedingungen</a>
            <span className="pull-right">© {ENV.copyright}</span>
          </p>
        </div>
      </footer>
    )
  }

  renderFooterMSL() {
    return (
      <footer className="footer">
        <p className="text-center">
        <span>© {ENV.copyright}</span>
        <span> | </span>
        <a href="https://www.smarterlernen.at/impressum/">Impressum</a>
        <span> | </span>
        <a href="https://www.smarterlernen.at/datenschutz/">Datenschutz</a>
        <span> | </span>
        <a href="https://www.smarterlernen.at/nutzungsbedingungen/">Nutzungsbedingungen</a>
        </p>
      </footer>
    );
  }

  render(){
    if (this.props.history.location.pathname === '/' && ENV.brand != 'eba') return null;

    if(ENV.brand == 'rlb'){
      return this.renderFooterRLB()
    }

    if (ENV.brand == 'msl') {
      return this.renderFooterMSL()
    }
    return (
      <footer className="footer">
        <p className="text-center">
          <span>© {ENV.copyright}</span>
          <span> | </span>
          {this.renderImpressLink()}
        </p>
      </footer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/footer/footer.js